import { render, staticRenderFns } from "./MediaSubPage.vue?vue&type=template&id=ca9e89ee&"
import script from "./MediaSubPage.vue?vue&type=script&lang=js&"
export * from "./MediaSubPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CHeading: require('@chakra-ui/vue').CHeading, CSimpleGrid: require('@chakra-ui/vue').CSimpleGrid, CBox: require('@chakra-ui/vue').CBox})
